import { api } from './api';

export type StagesPayload = Array<{
    name: string;
    display_name: string;
}>;

export const loadStages = (): Promise<StagesPayload> =>
    api.get('/stages').then((res) => res.data);
